__webpack_require__.p = "/curso-blender/";